/**
 * defa.views.UnitSnippet
 * A snippet for a Unit.
 * @version 1.2.1
 */
import Snippet from 'scripts/poppet/snippet';

const channelUser = Bb.Radio.channel( 'user' ),
	  channelLayout = Bb.Radio.channel( 'layout' );

const selectors = {
	container: '[data-region=snippet-container]',
};

const UnitSnippet = Snippet.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	expandedNavState  : 'unit:control:overview',
	compressedNavState: 'unit:list',
	className         : function () {
		return 'snippet expandable' + this.getElementClasses();
	},
	
	regions: {
		container: selectors.container,
	},
	
	modelEvents: {
		'change:transientOffline': 'onConnectionChanged',
		'change:alias' : 'onAliasChanged',
	},
	
	templateContext: function () {
		
		let superContext = Snippet.prototype.templateContext.call( this );
		
		return _.extend( superContext, {
			attributes       : this.getAnchorAttributes(),
			isPreExpanded    : this._isPreExpanded(),
			iconClass        : this.getIconClasses(),
			canExpand        : true,
			header           : this.model.get( 'alias' ),
			hasBackButton    : this.hasBackButton(),
			hasContainer     : true,
			hasNotifications : this.model.has( 'transientNotifications' ),
			hasMessage       : true,
			hasRipple        : false,
			hasSecondaryTitle: true,
			hasDelete        : this.hasDelete(),
		} );
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	
	/**
	 * Triggers when the user clicks the snippet when it is busy [data-click=snippet-busy].
	 * @overwrite
	 * @void
	 */
	onClickBusy: function ( event ) {
		event.preventDefault();
		
		if ( this.$el.find( '.snippet-open' ).hasClass( 'updating' ) ) {
			this.showUpdateText();
		}
	},
	
	/**
	 * Triggers when the model changes the transientOffline attribute.
	 * @void
	 */
	onConnectionChanged: function ( event ) {
		var family = this.model.get('family').toLowerCase();
		var state = '';
		var previousState = '';
		if(family === 'bluetooth') {
			previousState =  '-' + (this.model.get('transientOffline') ? 'online' : 'offline');
			state = '-' + (this.model.get('transientOffline') ? 'offline' : 'online');
		}
		
		let previousIconClass = 'icon-' + family + previousState;
		if ( this.$el.find( '.snippet-open' ).hasClass( previousIconClass ) ) {
			this.$el.find( '.snippet-open' ).removeClass( previousIconClass );
			this.$el.find( '.snippet-open' ).addClass('icon-' + family + state);
		}
	},
	
	/**
	 * Triggers when the model changes the alias attribute.
	 * @void
	 */
	onAliasChanged: function ( event ) {
		this.$el.find('.snippet-title').html(this.model.get('alias'));
	},
	
	
	/**
	 * Triggers when the user clicks the open part of the snippet.
	 * @overwrite
	 * @void
	 */
	onClickOpen: function ( event ) {
		event.preventDefault();
		
		// !TODO: The updater is broken atm due to refactor of toggle-expander and consolidation of iconography. plxfix!
		if ( this.$el.find( '.snippet-open' ).hasClass( 'updating' ) ) {
			this.showUpdateText();
		} else {
			Snippet.prototype.onClickOpen.call( this, event );
		}
		
	},
	
	/**
	 * Triggeres when the user clicks the "back" button.
	 * @void
	 */
	onClickBack: function ( event ) {
		event.preventDefault();
		this.trigger( 'nav', 'unit:list' ); // a device would always navigate back to the unit list.
	},
	
	/**
	 * Triggeres when the user clicks the "upgrade" button.
	 * @void
	 */
	onChildviewUpgrade: function ( childview ) {
		this.trigger('upgrade', childview);
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Checks if the snippet should render a back button.
	 * @void
	 */
	hasBackButton: function () {
		return ( channelUser.request( 'units' ).length > 1 );
	},
	
	/**
	 * Checks if the snippet should render a delete button.
	 * @void
	 */
	hasDelete: function () {
		return this.model.get('family').toLowerCase() == 'bluetooth' &&
			   ( channelLayout.request( 'is:native' ) );
	},


	/**
	 * Displays the secondary title for three seconds.
	 * @void
	 */
	showUpdateText: function () {
		
		let self = this;
		
		if ( !self.updating ) {
			
			self.updating = true;
			
			self.ui.header.fadeTo( 200, 0 );
			self.ui.secondary.fadeTo( 200, 1 );
			
			setTimeout( function () {
				
				self.ui.header.fadeTo( 200, 1 );
				self.ui.secondary.fadeTo( 200, 0 );
				
				self.updating = false;
				
			}, 3000 );
			
		}
	},
	
	/**
	 * Controls the update-state of the snippet.
	 * @param {Object} options  An options object containing the update state.
	 * @void
	 */
	updateState: function ( options ) {
		
		options = options || {};
		
		if ( !options.progress ) {
			//Upgrade stopped. Reset elements
			this.$el.find( '.snippet-bar' ).remove();
			this.$el.find('.progress-text').remove();
			this.$el.find( '.snippet-open' ).removeClass( 'updating' );
			// Remove snippet-busy and reset to toggle-expand
			this.$el.find('.snippet-open').removeAttr('data-click');
			this.$el.find('.snippet-open').attr('data-toggle', 'expand-spoiler');
			
		} else {
			// if the snippet isn't updating yet, add that it's updating
			if ( !this.$el.find( '.snippet-open' ).hasClass( 'updating' ) ) {
				this.$el.find( '.snippet-open' ).addClass( 'updating' );
				
				// Set snippet-busy instead of toggle-expand when updating
				this.$el.find( '.snippet-open' ).removeAttr('data-toggle');
				this.$el.find( '.snippet-open' ).attr('data-click', 'snippet-busy');
			}
			
			//Progress information
			if ( this.$el.find('.progress-text').length <= 0 ) {
				this.$el.append('<span class="progress-text"></span> ');
			}
			
			// if the bar isn't made, create it
			if ( this.$el.find( '.snippet-bar' ).length <= 0 ) {
				this.$el.append( '<span class="snippet-bar"></span>' );
			}
			
			// set the bar width to the progress param
			this.$el.find( '.snippet-bar' ).css( 'width', (options.progress * 0.95) + '%' );
			this.$el.find('.progress-text').html(options.progress  + '%');
		}
	},
	
	/**
	 * Creates the needed classes based on the model's variables.
	 * @return {String}  A space-separated string of classes.
	 */
	getElementClasses: function () {
		
		let html5 = '';
		
		//html5 += this.model.get( 'family' ).toLowerCase();
		//html5 += ( this.model.get( 'tested' ))
		//		? ' tested'
		//		: ' not-tested';
		html5 += ( this.model.get( 'transientOffline' ) )
				 ? ' offline'
				 : '';
		html5 += ( this.options.state )
				 ? ' ' + this.options.state
				 : '';
		
		html5 += ( this.hasBackButton() )
				 ? ' has-back-button'
				 : '';
		
		return html5;
	},
	
	getIconClasses: function () {
		
		var family = this.model.get('family').toLowerCase();
		let state = '';
		if(family === 'bluetooth') {
			state = '-' + (this.model.get('transientOffline') ? 'offline' : 'online');
		}
		
		return 'icon icon-svg icon-labelled icon-' + family + state;
		
	},
	
	/**
	 * Adds additional attributes to the main anchor.
	 * @return {String} A string of extra html-attributes.
	 */
	getAnchorAttributes: function () {
		
		return ( this.model.get( 'transientOffline' ) )
			   ? ' disabled'
			   : '';
	},
	
	/**
	 * Checks if the UnitSnippet is already expanded.
	 * @returns {boolean} True if expanded is the current state, false if not.
	 * @private
	 */
	_isPreExpanded: function() {
		
		return 'expanded' === this.options.state;
	},
	
} );

export default UnitSnippet;